
import React, { useState } from 'react';
import { Layout, Menu, Typography, Card, Row, Col, Button, Divider, message } from 'antd';
import { UserOutlined, DashboardOutlined, TeamOutlined, FileTextOutlined, UsergroupAddOutlined, SafetyCertificateOutlined, QuestionCircleOutlined, BarsOutlined, BellOutlined, LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import ViewList from './ViewList';
import AdminSupportRequests from './AdminSupportRequests'; // Nom original conservé
import ViewListProvider from './ViewListProvider';
import VerificationsProvider from './VerificationsProvider';
import AdminSupportProvider from './AdminSupportProvider';
import ViewAllProvider from './ViewAllProvider';
import AddCategoryProvider from './AddCategoryProvider';
import './SuperAdminDashboard.css';

const { Header, Content, Sider } = Layout;
const { Text } = Typography;

const SuperAdminDashboard = () => {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [listType, setListType] = useState(null);
  const navigate = useNavigate();

  const latestUsers = [
    { date: '22/04/2025', name: 'David T.F.', ip: '192.030.222.222' },
    { date: '21/04/2025', name: 'Arol B.', ip: '192.030.555.555' },
  ];

  const latestServiceProviders = [
    { name: 'Dave County services', category: 'Temporal Housing', ip: '192.030.222.222' },
    { name: 'Bush County services', category: 'mental wellness', ip: '192.030.555.555' },
  ];

  const supportPending = [
    { date: '21/04/2025', user: 'David T.', provider: 'Dave County Service' },
    { date: '19/04/2025', user: 'Arol', provider: 'Bush County Service' },
  ];

  const handleLogout = async () => {
    try {
      const response = await fetch('/backend/superadmin_logout.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (response.ok) {
        message.success('Déconnexion réussie !');
        navigate('/superadminlogin');
      } else {
        const result = await response.json();
        message.error(result.error || 'Erreur lors de la déconnexion.');
      }
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
      message.error('Erreur réseau lors de la déconnexion.');
    }
  };

  const handleMenuClick = (e) => {
    if (e.key === '2-1') {
      setCurrentPage('viewList');
      setListType('users');
    } else if (e.key === '4-1') {
      setCurrentPage('viewListProvider');
      setListType(null);
    } else if (e.key === '3') {
      setCurrentPage('supportRequests');
      setListType(null);
    } else if (e.key === '5') {
      setCurrentPage('verificationsProvider');
      setListType(null);
    } else if (e.key === '6') {
      setCurrentPage('adminSupportProvider');
      setListType(null);
    } else if (e.key === '7-2') {
      setCurrentPage('viewAllProvider');
      setListType(null);
    } else if (e.key === '7-1') {
      setCurrentPage('addCategoryProvider');
      setListType(null);
    } else {
      setCurrentPage('dashboard');
      setListType(null);
    }
  };

  const DashboardContent = () => (
    <>
      <div className="welcome-section">
        <Text className="welcome-text">Welcome back, NH Guide!</Text>
        <br />
        <Text className="welcome-subtext">Super Admin</Text>
        <Divider className="welcome-divider" />
      </div>
      <Row gutter={[24, 24]} className="stats-row">
        <Col xs={24} sm={12} md={6}>
          <Card className="stat-card blue">
            <div className="stat-icon">📄</div>
            <Text className="stat-title">Total Support Requests</Text>
            <div className="stat-value-wrapper">
              <Text className="stat-value">4</Text>
              <Text className="stat-arrow">➜</Text>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card className="stat-card navy">
            <div className="stat-icon">👥</div>
            <Text className="stat-title">Total connected Users</Text>
            <div className="stat-value-wrapper">
              <Text className="stat-value">13</Text>
              <Text className="stat-arrow">➜</Text>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card className="stat-card gray">
            <div className="stat-icon">🤝</div>
            <Text className="stat-title">Service Providers</Text>
            <div className="stat-value-wrapper">
              <Text className="stat-value">10</Text>
              <Text className="stat-arrow">➜</Text>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card className="stat-card slate">
            <div className="stat-icon">🔍</div>
            <Text className="stat-title">Users</Text>
            <div className="stat-value-wrapper">
              <Text className="stat-value">15</Text>
              <Text className="stat-arrow">➜</Text>
            </div>
          </Card>
        </Col>
      </Row>
      <Row gutter={[24, 24]} className="data-row">
        <Col xs={24} md={8}>
          <Card className="data-card">
            <div className="card-header blue">Latest Users</div>
            {latestUsers.map((user, index) => (
              <div key={index}>
                <div className="data-item">
                  <Text className="data-secondary">{user.date}</Text>
                  <div className="data-name-wrapper">
                    <span className="data-icon">👤</span>
                    <Text className="data-primary">{user.name}</Text>
                  </div>
                  <Text className="data-secondary small">{user.ip}</Text>
                </div>
                {index < latestUsers.length - 1 && <Divider className="data-divider" />}
              </div>
            ))}
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card className="data-card">
            <div className="card-header navy">Latest Service Providers</div>
            {latestServiceProviders.map((provider, index) => (
              <div key={index}>
                <div className="data-item">
                  <div className="data-name-wrapper">
                    <span className="data-icon">🏢</span>
                    <Text className="data-primary">{provider.name}</Text>
                  </div>
                  <Text className="data-secondary">{provider.category}</Text>
                  <Text className="data-secondary small">{provider.ip}</Text>
                </div>
                {index < latestServiceProviders.length - 1 && <Divider className="data-divider" />}
              </div>
            ))}
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card className="data-card">
            <div className="card-header slate">Support Pending</div>
            {supportPending.map((item, index) => (
              <div key={index}>
                <div className="data-item">
                  <Text className="data-secondary">{item.date}</Text>
                  <div className="data-name-wrapper">
                    <span className="data-icon">👤</span>
                    <Text className="data-primary">{item.user}</Text>
                  </div>
                  <Text className="data-secondary">{item.provider}</Text>
                </div>
                {index < supportPending.length - 1 && <Divider className="data-divider" />}
              </div>
            ))}
          </Card>
        </Col>
      </Row>
    </>
  );

  return (
    <Layout style={{ minHeight: '100vh', background: '#FFFFFF' }}>
      <Header className="header">
        <div className="logo">
          <UserOutlined style={{ color: '#4299E1', marginRight: 8 }} />
          <span className="logo-text">NH Guide</span>
        </div>
        <Button
          className="logout-btn"
          variant="outlined"
          startIcon={<LogoutOutlined />}
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Header>
      <Layout>
        <Sider width={350} className="sidebar">
          <Menu
            mode="inline"
            defaultSelectedKeys={['1']}
            className="sidebar-menu"
            onClick={handleMenuClick}
          >
            <Menu.Item key="1" icon={<DashboardOutlined className="menu-icon" />}>
              <span className="menu-dot">•</span> Dashboard
            </Menu.Item>
            <Menu.SubMenu key="2" icon={<TeamOutlined className="menu-icon" />} title="User Management">
              <Menu.Item key="2-1">Name List</Menu.Item>
            </Menu.SubMenu>
            <Menu.Item key="3" icon={<FileTextOutlined className="menu-icon" />}>
              Support Tickets
            </Menu.Item>
            <Menu.SubMenu key="4" icon={<UsergroupAddOutlined className="menu-icon" />} title="Service Provider Management">
              <Menu.Item key="4-1">Provider List</Menu.Item>
            </Menu.SubMenu>
            <Menu.Item key="5" icon={<SafetyCertificateOutlined className="menu-icon" />}>
              Verifications
            </Menu.Item>
            <Menu.Item key="6" icon={<QuestionCircleOutlined className="menu-icon" />}>
              Support
            </Menu.Item>
            <Menu.SubMenu key="7" icon={<BarsOutlined className="menu-icon" />} title="Categories">
              <Menu.Item key="7-1">New Category</Menu.Item>
              <Menu.Item key="7-2">All Categories</Menu.Item>
            </Menu.SubMenu>
            <Menu.SubMenu key="8" icon={<BellOutlined className="menu-icon" />} title="Notifications">
              <Menu.Item key="8-1">User Notifications</Menu.Item>
              <Menu.Item key="8-2">Provider Notifications</Menu.Item>
              <Menu.Item key="8-3">Automated Messages</Menu.Item>
            </Menu.SubMenu>
          </Menu>
        </Sider>
        <Layout style={{ background: '#F7FAFC' }}>
          <Content className="content">
            {currentPage === 'dashboard' ? (
              <DashboardContent />
            ) : currentPage === 'viewList' ? (
              <ViewList type={listType} />
            ) : currentPage === 'viewListProvider' ? (
              <ViewListProvider />
            ) : currentPage === 'verificationsProvider' ? (
              <VerificationsProvider />
            ) : currentPage === 'adminSupportProvider' ? (
              <AdminSupportProvider />
            ) : currentPage === 'viewAllProvider' ? (
              <ViewAllProvider />
            ) : currentPage === 'addCategoryProvider' ? (
              <AddCategoryProvider />
            ) : (
              <AdminSupportRequests />
            )}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default SuperAdminDashboard;
